// Variant normalization helpers shared by template components

export type PreviewVariant =
  | "professional-classic"
  | "elegant-looking"
  | "modern-clean"
  | "golden-view"
  | "classic-modular";

export const KNOWN_VARIANTS: PreviewVariant[] = [
  "professional-classic",
  "elegant-looking",
  "modern-clean",
  "golden-view",
  "classic-modular",
];

const ALIASES: Record<string, PreviewVariant> = {
  "royal-ocean": "professional-classic",
  "royal_ocean": "professional-classic",
  royalocean: "professional-classic",
  classic: "professional-classic",
  elegant: "elegant-looking",
  modern: "modern-clean",
  modular: "classic-modular",
  grid: "classic-modular",
  blocks: "classic-modular",
  golden: "golden-view",
  gold: "golden-view",
};

export function normalizeComponentKey(raw?: string): PreviewVariant | "" {
  const s = String(raw ?? "").trim().toLowerCase();
  if (!s) return "";
  if ((KNOWN_VARIANTS as string[]).includes(s)) return s as PreviewVariant;
  if (ALIASES[s]) return ALIASES[s];

  if (/royal.*ocean/.test(s)) return "professional-classic";
  if (/classic.*modular|modular|grid|blocks/.test(s)) return "classic-modular";
  if (/modern.*clean|modern/.test(s)) return "modern-clean";
  if (/gold(en)?/.test(s)) return "golden-view";
  if (/elegant/.test(s)) return "elegant-looking";

  return "";
}

// Accept legacy shapes from API or seeds that have `variant` only.
export function coerceTemplateVariant(
  componentKey?: string,
  variant?: string,
): PreviewVariant | "" {
  return (
    normalizeComponentKey(componentKey) ||
    normalizeComponentKey(variant) ||
    ""
  );
}

// Convenience for FE: returns null if invalid so we don't render broken previews.
export function ensureTemplateVariant(
  componentKey?: string,
  variant?: string,
): PreviewVariant | null {
  const v = coerceTemplateVariant(componentKey, variant);
  return v || null;
}
